import React from 'react';
import { IconProps } from '../../../lib/types';

const FilterIcon: React.FC<IconProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24.095"
      height="16.866"
      viewBox="0 0 24.095 16.866"
      className={className}
    >
      <path
        d="M22.589 0a1.506 1.506 0 011.107 2.525L18.071 8.64v5.817a1.205 1.205 0 01-1.928.964l-2.409-1.807a1.2 1.2 0 01-.482-.964V8.64L7.628 2.525A1.44 1.44 0 017.357.9 1.489 1.489 0 018.701 0zM1.506 2.409h4.672a2.722 2.722 0 00.561.93l5.308 5.737v.663l-1.2 1.31v4.612a1.205 1.205 0 01-1.928.964l-2.413-1.807a1.2 1.2 0 01-.482-.964v-2.8L.398 4.936A1.506 1.506 0 011.506 2.41z"
        className="a"
      ></path>
    </svg>
  );
};

export default FilterIcon;
